import { Fragment } from 'react';
import './styles.scss';

import JasariLogo from '../../assets/images/logo/logo-khaihoanprime.png';

const timelineData = [
  {
    time: 5,
    locations: ['Trường THPT\nNguyễn Thị Định', 'Trường THCS\nBình Đông'],
  },
  {
    time: 10,
    locations: ['Bệnh viện\nQuốc tế City', 'Aeon mall\nBình Tân'],
  },
  {
    time: 15,
    locations: ['Chợ\nBình Hưng', 'Bến xe\nMiền Tây'],
  },
  {
    time: 20,
    locations: ['Chợ\nBến Thành', 'Phú Mỹ Hưng'],
  },
  {
    time: 30,
    locations: ['Sân bay\nTân Sơn Nhất', 'Trung tâm\nQuận 1'],
  },
];

export const Timeline = ({ className, logoText = '{LOGO JASARI}' }) => {
  return (
    <>
      <div className={`timeline-container ${className || ''}`}>
        <div className="timeline-logo">
          <img src={JasariLogo} alt="" />
        </div>
        <div className="timeline-content">
          <div className="timeline-vertical-line">
            <Fragment>
              <div className="timeline-point">
                <div className="time-label" />
                <div className="point-marker"></div>
              </div>
              {timelineData.map((item, index) => (
                <div className="timeline-point" key={index}>
                  <div className="time-label">{item.time} Phút</div>
                  <div className={`location-container`}>
                    <div className="point-marker"></div>
                    <div className={`horizontal-line`}></div>
                    <div className="locations">
                      <div className="location" />
                      {item.locations.map((location, locIndex) => (
                        <div
                          className={`location ${
                            locIndex % 2 === 0 ? 'even' : 'odd'
                          }`}
                          key={locIndex}
                        >
                          <div className="location-name">{location}</div>
                          <div className="location-dot"></div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </Fragment>
            <div className="timeline-arrow"></div>
          </div>
        </div>
      </div>
      <div className="timeline-mobile">
        <div className="logo">
          <img src={JasariLogo} alt="" />
        </div>
        <div className="timeline-container-mobile">
          <div className="horizontal-line"></div>
          <div className="timeline-arrow"></div>

          {timelineData.map((item, index) => (
            <div className="timeline-point-mobile" key={index}>
              <div className="time-label-mobile">{item.time} Phút</div>
              <div className="point-marker-mobile"></div>
              <div className="locations-mobile">
                {item.locations.map((location, locIndex) => (
                  <div
                    className={`location-mobile ${
                      locIndex % 2 === 0 ? 'even' : 'odd'
                    }`}
                    key={locIndex}
                  >
                    <span className="location-name-mobile">{location}</span>
                    <div className="location-dot-mobile"></div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
